import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const isSuspended = localStorage.getItem("isSuspended");

  // If token exists → allow access
  if (token) return children;

  // If user is suspended → stay on login page (modal will handle)
  if (isSuspended) return children;

  // Else → redirect to register/login
  return <Navigate to="/register" replace />;
};

export default PrivateRoute;
